document.addEventListener("DOMContentLoaded", function () {
    const collectionsSliderWrapper = document.querySelector(".product-grid");
    // La sección del carousel no está en todas las páginas: sin esto, TypeError en consola.
    if (!collectionsSliderWrapper) return;
    const collectionsDots = document.querySelectorAll(".collections-container .slider-dot");
    const collectionsProductCards = document.querySelectorAll(".product-grid .product-card");

    let currentIndex = 0;
    const gap = parseInt(getComputedStyle(collectionsSliderWrapper).gap) || 20;

    function updateCollectionSlider() {
        const scrollAmount = collectionsProductCards[0].offsetWidth + gap;
        collectionsSliderWrapper.scrollTo({
            left: currentIndex * scrollAmount,
            behavior: "smooth"
        })

        // Update active dot
        collectionsDots.forEach((dot, index) => {
            dot.classList.toggle("active", index === currentIndex);
        });
    }

    collectionsDots.forEach((dot, index) => {
        dot.addEventListener("click", function () {
            currentIndex = index;
            updateCollectionSlider();
        });
    });

    updateCollectionSlider();

    // Update dots on manual scroll
    collectionsSliderWrapper.addEventListener("scroll", function () {
        const scrollLeft = collectionsSliderWrapper.scrollLeft;
        const scrollAmount = collectionsProductCards[0].offsetWidth + gap;
        currentIndex = Math.round(scrollLeft / scrollAmount);
        collectionsDots.forEach((dot, index) => {
            dot.classList.toggle("active", index === currentIndex);
        });
    });

    const tabs = document.querySelectorAll('.tab-button');
    const collections = document.querySelectorAll('.collection-products');

    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            // Remove active class from all tabs and collections
            tabs.forEach(t => t.classList.remove('tab-active'));
            collections.forEach(c => c.classList.remove('active'));

            // Add active class to the clicked tab and corresponding collection
            this.classList.add('tab-active');
            document.getElementById('collection-' + this.getAttribute('data-collection')).classList.add('active');
        });
    });

    // Set first collection as active by default
    if (tabs.length > 0) {
        tabs[0].click();
    }
});
